module.exports = __webpack_public_path__ + "static/media/macbook_pro_13.699876d8.svg";